/**
 * Pre-compiled es messages for ComboBox
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  clearSelection: `Borrar selección`,
  options: `Menú de opciones`,
  selectedValues: `Valores seleccionados`,
  toggleOptions: `Opciones de conmutación`,
};
